import React, { useEffect, useRef } from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import img from "static/image/onboarding/start_2.png";
import { BottomNextButtonTmp } from "../../../../components/common/BottomNextButtonTmp";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";
import { trackCapiStandardEvent } from "../../../../analytics/metaCapi";
import useGtagConversion from "../../../../hooks/useGtagConversion";

export default function Start_2_V6({
  version = "v6",
}: {
  version?: MktVersionTypes;
}) {
  const navigate = useNavigate();

  const trackGtagEvent = useGtagConversion();

  const handleNext = () => {
    navigate(`/${versionToPathPrefix(version)}-onboarding/start/3`, {
      replace: true,
    });
  };

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {
    trackCapiStandardEvent("ViewContent");
    trackGtagEvent("ViewContent", "v4");
  });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "70vh" }}>
      <Stack
        sx={{
          height: "100%",
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack spacing={2}>
          <CustomTypography
            variant="Subtitle"
            fontWeight={700}
            sx={{
              color: theme.vars.palette.Content.Highlight,
            }}
          >
            1:1 전담 코치와 함께 진행합니다.
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            매일 코치가 함께하며 프로그램 진행을 도와드립니다.
          </CustomTypography>
        </Stack>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 0,
            marginTop: "50px",
          }}
        >
          <img
            src={img}
            alt={"onboarding"}
            style={{
              width: "280px",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      </Stack>
      <BottomNextButtonTmp
        disabled={false}
        onClick={handleNext}
        text={"다음"}
        highlightBackground={true}
      />
    </Box>
  );
}
